<template>
    <b-modal id="user-modal" size="xl" header-class="p-4 bg-light border-0" hide-footer centered @hidden="onClose" @show="loadData">
        <template #modal-title>
            <div class="d-flex align-items-center ">
                <h4 class="font-size-18 font-weight-semibold mb-0">Gestion des utilisateurs</h4>
            </div>
        </template>

        <div class="position-relative p-3" style="min-height: 200px">
            <Loader :loading="loading" />

            <div class="row">
                <div class="col-3 pr-4 border-right">
                    <vue-form-generator ref="form" tag="div" :schema="formSchema" :model="values" :options="{ validateAfterChanged: true }" />
                </div>
                <div class="col-4 px-4 border-right">
                    <vue-form-generator tag="div" :schema="efpSchema" :model="values" :options="{ validateAfterChanged: true }" />
                </div>
                <div class="col pl-4">
                    <vue-form-generator tag="div" :schema="rolesSchema" :model="values" :options="{ validateAfterChanged: true }" />
                </div>
            </div>
        </div>

        <div class="d-flex bg-white align-items-center justify-content-end mt-3 pb-2 px-4">
            <b-button class="ml-2 px-3" pill @click="$bvModal.hide('user-modal')">Annuler</b-button>
            <q-button class="ml-2 px-3" pill variant="primary" :loading="submitLoading" @click="submitChanged">Valider les changements</q-button>
        </div>
    </b-modal>
</template>

<script>
    import Loader from "./ui/loader";

    let LISTS = {};

    export default {
        components: { Loader },
        props: {
            user: {}
        },
        data: () => ({
            values: {
                active: true
            },
            directionsList: [],
            complexesList: [],
            efpList: [],
            loading: false,
            submitLoading: false
        }),
        methods: {
            async submitChanged() {
                if (!this.$refs.form.validate()) return;

                try {
                    this.submitLoading = true;
                    var values = {...this.values};
                    for (const key in values) {
                        if (typeof values[key] == "boolean")
                            values[key] = Number(values[key]);
                    }
                    await this.$axios.post("/users", values);
                    this.$emit("submited");
                    this.$bvModal.hide("user-modal");
                } finally {
                    this.submitLoading = false;
                }
            },
            async loadData() {
                if (!this.user) return;

                this.loading = true;
                const resp = await this.$axios.get(`/users/${this.user}`);
                this.values = resp;
                this.loading = false;
            },
            onClose() {
                this.values = {
                    active: true
                };
            }
        },
        watch: {
            "values.direction": function(direction) {
                this.complexesList = LISTS.complexes.filter(item => item.idDirection == (direction && direction.id));
                this.efpList = [];
                if (!direction) {
                    this.values.complexe = null;
                    this.values.efp = [];
                }
            },
            "values.complexe": function(complexe) {
                this.efpList = LISTS.efp.filter(item => item.idComplexe == (complexe && complexe.id));
                if (!complexe) {
                    this.values.efp = [];
                }
            },
            "values.roles": function(roles) {
                if (!roles) return;
                if (roles.includes("edit-stagiaire") && !roles.includes("view-stagiaire")) roles.push("view-stagiaire");
                if (roles.includes("edit-efp") && !roles.includes("view-efp")) roles.push("view-efp");
                if (roles.includes("edit-filiere") && !roles.includes("view-filiere")) roles.push("view-filiere");
                if (roles.includes("edit-utilisateur") && !roles.includes("view-utilisateur")) roles.push("view-utilisateur");

                this.roles = roles;
            }
        },
        mounted() {
            this.$axios.get("/efp/directions/options").then(({ directions, complexes, efp }) => {
                LISTS = {
                    directions,
                    complexes,
                    efp
                };
                this.directionsList = directions;
                this.complexesList = complexes;
            });
        },
        computed: {
            formSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Matricule",
                                    model: "code",
                                    styleClasses: "font-size-12 text-muted",
                                    required: true,
                                    max: 10,
                                    validator: ["required", "string"]
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Nom complet",
                                    model: "nom",
                                    styleClasses: "font-size-12 text-muted",
                                    required: true,
                                    max: 50,
                                    validator: ["required", "string"]
                                },
                                {
                                    type: "b-input",
                                    inputType: "password",
                                    label: "Mot de passe",
                                    model: "pass",
                                    styleClasses: "font-size-12 text-muted",
                                    required: false && true,
                                    validator: false && "required"
                                },
                                {
                                    type: "b-checkbox",
                                    label: "Statut de l'utilisateur",
                                    text: this.values.active ? "Actif" : "Inactif",
                                    model: "active",
                                    switch: true,
                                    size: "lg",
                                    styleClasses: "font-size-12 text-muted",
                                }
                            ]
                        }
                    ]
                };
            },
            efpSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Fonction",
                                    model: "fonction",
                                    styleClasses: "font-size-12 text-muted"
                                },
                                {
                                    type: "multiselect",
                                    label: "Direction",
                                    model: "direction",
                                    styleClasses: "font-size-12 text-muted",
                                    values: this.directionsList || []
                                },
                                {
                                    type: "multiselect",
                                    label: "Complexe",
                                    model: "complexe",
                                    styleClasses: "font-size-12 text-muted",
                                    values: this.complexesList || []
                                },
                                {
                                    visible: this.efpList.length,
                                    type: "b-checkbox",
                                    label: "EFP",
                                    model: "efp",
                                    stacked: true,
                                    styleClasses: "font-size-12 text-muted",
                                    valueField: "id",
                                    textField: "nom",
                                    options: this.efpList || []
                                }
                            ]
                        }
                    ]
                };
            },
            rolesSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "",
                            fields: [
                                {
                                    type: "b-checkbox",
                                    label: "Liste des rôles",
                                    model: "roles",
                                    stacked: true,
                                    switches: true,
                                    size: "lg",
                                    styleClasses: "font-size-12 text-muted",
                                    attributes: {
                                        class: "columns"
                                    },
                                    options: [
                                        { text: "Lancer une enquête", value: "start-quest" },
                                        { text: "Voir la liste des enquêtes", value: "view-quest" },
                                        { text: "Supprimer des enquêtes", value: "delete-quest" },
                                        { text: "Gestion des questions", value: "edit-question" },
                                        { text: "Voir la liste des stagiaires", value: "view-stagiaire" },
                                        { text: "Modifier les stagiaires", value: "edit-stagiaire" },
                                        { text: "Voir la liste des EFP", value: "view-efp" },
                                        { text: "Modifier les EFP", value: "edit-efp" },
                                        { text: "Voir la liste des filières", value: "view-filiere" },
                                        { text: "Modifier les filières", value: "edit-filiere" },
                                        { text: "Voir la liste des utilisateurs", value: "view-utilisateur" },
                                        { text: "Modifier les utilisateurs", value: "edit-utilisateur" },
                                        { text: "Importer les données", value: "import" }
                                    ]
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>

<style lang="scss">
    #user-modal {
        .field-b-checkbox {
            .bv-no-focus-ring {
                width: 100%;

                &.columns {
                    column-count: 2;
                    margin-top: 10px;

                    > * {
                        display: inline-block;
                        margin-top: 4px;

                        label {
                            span {
                                margin-top: 3px;
                            }
                        }
                    }
                }

                > * {
                    margin-bottom: 10px;
                    color: $dark;

                    label {
                        font-size: 12px;

                        span {
                            margin-top: 1px;
                        }
                    }
                }
            }
        }
    }
</style>
